import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "../src/assets/css/style.css";
import Layout from "./components/Layout";
import { Routes, Route } from "react-router-dom";
// import Pricing from "./components/Pricing";
import HomeV2 from "./components/HomeV2";
import Privacy from "./components/Privacy";
function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomeV2 />} />
        <Route path="/privacy-policy" element={< Privacy/>} />
        <Route path="/v2" element={<HomeV2 />} />
        {/* <Route path="/privacy" element={<Privacy />} /> */}
      </Route>
    </Routes>
  );
}

export default App;
